import Vue from 'vue'
import Vuex from 'vuex'
import { login as loginApi, logout as logoutApi, fetchMe as fetchMeApi } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    token: getToken() || null
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_TOKEN(state, token) {
      state.token = token
      setToken(token)
    },
    CLEAR_AUTH(state) {
      state.user = null
      state.token = null
      removeToken()
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const data = await loginApi({ username, password })
      commit('SET_TOKEN', data.token)
      commit('SET_USER', data.user)
      return data
    },
    async logout({ commit }) {
      try {
        await logoutApi()
      } finally {
        commit('CLEAR_AUTH')
      }
    },
    async fetchMe({ commit }) {
      const user = await fetchMeApi()
      commit('SET_USER', user)
      return user
    }
  }
})
